import React from "react";
import { icon } from "../../../config";
import { emailVariable, workFlowEmailTaskKeys } from "../../editor.Constant";

/**
 * EmailVariables component for rendering email variables
 * @author Muskan Thakur
 */
const EmailVariables = ({ acknowledgeMailEditor, taskKey, updateEmailVariable }) => {
  if (!acknowledgeMailEditor || !workFlowEmailTaskKeys.includes(taskKey)) {
    return null;
  }

  const filteredVariables =
    taskKey === "AcknowledgeEmail" ? emailVariable.filter((v) => v.varId !== "RefId") : emailVariable;

  return (
    <div className='custom-editor-section' id='editor-email-variable'>
      <div className='dt-editor-action'>{"Variables"}</div>
      <div className='chips-container'>
        {filteredVariables.map((emailVar) => (
          <div
            key={emailVar.name}
            className='d-flex align-items-center justify-content-between p-2 cursor-pointer workflow-variable-item'
            onClick={() => updateEmailVariable(emailVar)}>
            <div className='d-flex justify-content-between align-items-center'>
              <span>{icon.CHECK_CIRCLE}</span>
              <span className='ml-2'>{emailVar.label}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default React.memo(EmailVariables);
